import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, ViewEncapsulation, Inject, LOCALE_ID, HostListener, NgModule } from '@angular/core';
import * as i1 from '@accounting/accounting-services';
import { ContactsService, CountryCodes, Contact, PeriodType, CompanyService, FiscalYearService, AccountingServicesModule } from '@accounting/accounting-services';
import { getCompanyId } from '@blue/services/session';
import { LicenseAgreementService, RequestGrantService, LinkSessionService, AccessTokenService, QuickbooksReportDataService, QuickbooksOnlineServicesModule } from '@accounting/quickbooks-online-services';
import { environment, session } from '@blue/services';
import { has } from '@blue/services/licenses';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BentoModalConfirmationCloseReason, BentoModalConfirmationService, BentoModule } from '@bento/bento-ng';
import { BfmModule } from '@bento/bfm-ng';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { user } from '@blue/services/profile';
import { Subscription, of } from 'rxjs';
import { SmbCenterCompanyRegistartionService, SmbCenterSambaCompanyService, SmbCenterProductsService, OnBalanceServicesModule } from '@accounting/onbalance-services';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@accounting/accounting-services';
import * as ɵngcc2 from '@accounting/quickbooks-online-services';
import * as ɵngcc3 from '@ngx-translate/core';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from '@bento/bento-ng';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc8 from '@accounting/onbalance-services';
import * as ɵngcc9 from '@bento/bfm-ng';

function ExternalIntegrationComponent_h3_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "bmei.integration.integration"));
} }
function ExternalIntegrationComponent_bento_alert_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bento-alert", 7);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r1.noContactAlerts);
} }
function ExternalIntegrationComponent_bmei_contact_selector_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bmei-contact-selector", 8);
    ɵngcc0.ɵɵlistener("selectedContactChanged", function ExternalIntegrationComponent_bmei_contact_selector_3_Template_bmei_contact_selector_selectedContactChanged_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.updateSelectedContact(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("contacts", ctx_r2.contacts);
} }
function ExternalIntegrationComponent_bmei_quick_books_integration_component_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmei-quick-books-integration-component", 9);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("selectedContact", ctx_r3.selectedContact)("licenseAgreementSigned", ctx_r3.licenseAgreementSigned);
} }
function ExternalIntegrationComponent_bmei_onbalance_integration_component_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmei-onbalance-integration-component", 10);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("iacModel", ctx_r4.iacModel)("selectedContact", ctx_r4.selectedContact)("showOnbalanceConnectOptions", ctx_r4.showOnbalanceConnectOptions)("clientId", ctx_r4.clientId)("companyId", ctx_r4.companyId);
} }
function QuickBooksIntegrationCallbackComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "h1", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr", 2);
    ɵngcc0.ɵɵelementStart(5, "span", 3);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "bmei.qbo.success"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 4, "bmei.qbo.successMessage"));
} }
function QuickBooksIntegrationCallbackComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "h1", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr", 2);
    ɵngcc0.ɵɵelementStart(5, "span", 3);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "bmei.qbo.failure"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 4, "bmei.qbo.failureMessage"));
} }
function ContactSelectorComponent_select_7_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contact_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", contact_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(contact_r2.displayAs);
} }
function ContactSelectorComponent_select_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function ContactSelectorComponent_select_7_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.selectedContact = $event; });
    ɵngcc0.ɵɵtemplate(1, ContactSelectorComponent_select_7_option_1_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedContact);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.contacts);
} }
function QuickBooksIntegrationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelement(1, "img", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 6)(3, "div", 7)(4, "div");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(7, "div", 8)(8, "div", 7)(9, "div", 9);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(12, "div", 6)(13, "div", 10)(14, "div", 11);
    ɵngcc0.ɵɵelement(15, "span", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "input", 13);
    ɵngcc0.ɵɵlistener("click", function QuickBooksIntegrationComponent_div_5_Template_input_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.startConnectProcess(); });
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, "bmei.integration.integrateWith"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 5, "bmei.qbo.quickbooksOnline"));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("src", ctx_r0.connectToQuickBooksImageSource, ɵngcc0.ɵɵsanitizeUrl);
} }
function QuickBooksIntegrationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelement(1, "img", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 8)(3, "div", 14);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementStart(6, "span", 9);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementStart(10, "span", 9);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(12, "div", 6)(13, "div", 7)(14, "button", 15);
    ɵngcc0.ɵɵlistener("click", function QuickBooksIntegrationComponent_div_6_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.openDisconnectModal(); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 5, "bmei.qbo.companyLinked1"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.qboCompanyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 7, "bmei.qbo.companyLinked2"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(" " + ctx_r1.selectedContact.fullName);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 9, "bmei.integration.disconnect"), " ");
} }
function RequestPeriodModalComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const $data_r2 = ctx.data;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.dateFormatter.formatDate($data_r2.row.endDate));
} }
const _c0 = function (a0) { return { contactName: a0 }; };
const _c1 = function (a0, a1) { return { contact: a0, date: a1 }; };
function OnbalanceIntegrationComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "i", 20)(2, "span", 21);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵpipe(4, "date");
    ɵngcc0.ɵɵelement(5, "i", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(49);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(3, 2, "bmei.ob.invitationSent", ɵngcc0.ɵɵpureFunction2(8, _c1, ctx_r3._selectedContact.displayAs, ɵngcc0.ɵɵpipeBind2(4, 5, ctx_r3.invitedDate, ctx_r3.dateFormatString))), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngbTooltip", _r1);
} }
function OnbalanceIntegrationComponent_div_8_div_2_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 29);
    ɵngcc0.ɵɵlistener("click", function OnbalanceIntegrationComponent_div_8_div_2_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.openOnBalance(); });
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "i", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r6.isOpeningOB);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "bmei.ob.openOnBalance"), " ");
} }
function OnbalanceIntegrationComponent_div_8_div_2_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 31);
    ɵngcc0.ɵɵlistener("click", function OnbalanceIntegrationComponent_div_8_div_2_button_11_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.openDisconnectClientModal(); });
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "bmei.ob.clientUnlink.disconnect"));
} }
const _c2 = function (a0) { return { contact: a0 }; };
function OnbalanceIntegrationComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 23);
    ɵngcc0.ɵɵelement(2, "i", 24)(3, "span", 21);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 25);
    ɵngcc0.ɵɵtemplate(6, OnbalanceIntegrationComponent_div_8_div_2_button_6_Template, 5, 4, "button", 26);
    ɵngcc0.ɵɵelementStart(7, "button", 27);
    ɵngcc0.ɵɵlistener("click", function OnbalanceIntegrationComponent_div_8_div_2_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.openRequestPeriodModal(); });
    ɵngcc0.ɵɵelementStart(8, "b");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵpipe(10, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(11, OnbalanceIntegrationComponent_div_8_div_2_button_11_Template, 4, 3, "button", 28);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind2(4, 4, "bmei.ob.linkSuccess", ɵngcc0.ɵɵpureFunction1(9, _c2, ctx_r4._selectedContact.displayAs)), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.iacModel == null ? null : ctx_r4.iacModel.hasOBAccountantView);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(10, 7, "bmei.ob.requestPriorData"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.bmeiLicenseService == null ? null : ctx_r4.bmeiLicenseService.hasOnbalanceDisconnect);
} }
function OnbalanceIntegrationComponent_div_8_div_3_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 43);
    ɵngcc0.ɵɵlistener("click", function OnbalanceIntegrationComponent_div_8_div_3_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.sendInvite(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r14.emailToSend || ctx_r14.validateEmail());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, "bmei.ob.buttons.sendInvite"), " ");
} }
function OnbalanceIntegrationComponent_div_8_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 44)(1, "button", 45);
    ɵngcc0.ɵɵlistener("click", function OnbalanceIntegrationComponent_div_8_div_3_div_11_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.sendInvite(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 46);
    ɵngcc0.ɵɵlistener("click", function OnbalanceIntegrationComponent_div_8_div_3_div_11_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.openCancelInvitationConfirmationModal(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !ctx_r15.emailToSend || ctx_r15.validateEmail());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, "bmei.ob.buttons.reSendInvite"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 5, "bmei.ob.buttons.cancelInvite"), " ");
} }
function OnbalanceIntegrationComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "form", 32)(2, "label", 33);
    ɵngcc0.ɵɵelement(3, "span", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function OnbalanceIntegrationComponent_div_8_div_3_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.emailToSend = $event; });
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 36)(7, "label", 37);
    ɵngcc0.ɵɵelement(8, "span", 38);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "bento-combobox", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, OnbalanceIntegrationComponent_div_8_div_3_button_10_Template, 3, 4, "button", 40);
    ɵngcc0.ɵɵtemplate(11, OnbalanceIntegrationComponent_div_8_div_3_div_11_Template, 7, 7, "div", 41);
    ɵngcc0.ɵɵelementStart(12, "div", 42);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵpipe(14, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("validations", ctx_r5.validations);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("bfmLabel", ɵngcc0.ɵɵpipeBind1(5, 10, "bmei.ob.emailAddress"));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.emailToSend)("formControl", ctx_r5.email);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("itemsObservable", ctx_r5.planTypes$)("ngModel", ctx_r5.selfEmployedPlanType)("appendTo", ".bmei-ob-combobox-container");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.isInvited);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.isInvited);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(14, 12, "bmei.integration.requiredField"));
} }
function OnbalanceIntegrationComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, OnbalanceIntegrationComponent_div_8_div_1_Template, 6, 11, "div", 17);
    ɵngcc0.ɵɵtemplate(2, OnbalanceIntegrationComponent_div_8_div_2_Template, 12, 11, "div", 18);
    ɵngcc0.ɵɵtemplate(3, OnbalanceIntegrationComponent_div_8_div_3_Template, 15, 14, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isInvited && !ctx_r0.isLinked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isLinked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isLinked);
} }
function OnbalanceIntegrationComponent_ng_template_48_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 47)(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 48);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "bmei.ob.tooltip.title"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, "bmei.ob.tooltip.text"));
} }
class BmeiContactService {
    constructor(contactsService) {
        this.contactsService = contactsService;
    }
    /**
     * Loads related contacts for giving companyId and contactId
     * @param companyId - companyId
     * @param contactId - contactId
     * @returns array of related contacts
     */
    loadRelatedContacts(companyId, contactId) {
        return this.contactsService.getRelatedContacts(companyId, contactId);
    }
    /**
     * Loads related contacts for giving companyId and contactId filtered by some criteria
     * @param companyId - companyId
     * @param contactId - contactId
     * @param filter - JSON object with filtering criteria
     * @returns filtered array of related contacts
     */
    loadRelatedContactsFiltered(companyId, contactId, filter) {
        return this.contactsService.getRelatedContacts(companyId, contactId, filter);
    }
    /**
     * Get relationship for gining companyId and ownerId
     * @param companyId - companyId
     * @param ownerId - ownerId
     * @returns array of related contacts relationship
     */
    getRelationships(companyId, ownerId) {
        return this.contactsService.getRelationships(companyId, ownerId);
    }
    setSelectedContact(_contact) {
        this.selectedContact = _contact;
    }
    getSelectedContactId() {
        return this.selectedContact.id;
    }
    getSelectedContactName() {
        return this.selectedContact.fullName;
    }
    getSelectedContact() {
        return this.selectedContact;
    }
}
BmeiContactService.ɵfac = function BmeiContactService_Factory(t) { return new (t || BmeiContactService)(ɵngcc0.ɵɵinject(ɵngcc1.ContactsService)); };
BmeiContactService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmeiContactService_Factory() { return new BmeiContactService(i0.ɵɵinject(i1.ContactsService)); }, token: BmeiContactService, providedIn: "root" });
BmeiContactService.ctorParameters = () => [
    { type: ContactsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmeiContactService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.ContactsService }]; }, null); })();

const IAC = {
    TrialBalanceIntegrationQB: 'TrialBalanceIntegrationQB',
    WorkpapersIntegrationQB: 'WorkpapersIntegrationQB',
    TrialBalanceIntegrationOB: 'TrialBalanceIntegrationOB',
    WorkpapersIntegrationOB: 'WorkpapersIntegrationOB',
    OnBalanceAccountantView: 'OnBalance.AccountantView',
    IntegrationQBO: 'IntegrationQBO',
    IntegrationOB: 'IntegrationOB',
};

const EntityType = {
    GBINDIVIDUAL: 'GBINDIVIDUAL',
    GBSOLETRADE: 'GBSOLETRADE',
    GBRENTALPROPERTIES: 'GBRENTALPROPERTIES',
    GBFURNISHEDHOLIDAYLETTINGS: 'GBFURNISHEDHOLIDAYLETTINGS',
};

class BmeiLicenseService {
    constructor() {
        this.hasOnBalanceLinkingLicense = false;
        this.hasOnbalanceDisconnect = false;
    }
    loadFrp() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.hasOnBalanceLinkingLicense = yield has('Onbalance.Linking');
                this.hasOnbalanceDisconnect = yield has('Onbalance.Disconnect');
            }
            catch (_a) {
                this.hasOnBalanceLinkingLicense = false;
                this.hasOnbalanceDisconnect = false;
            }
        });
    }
}
BmeiLicenseService.ɵfac = function BmeiLicenseService_Factory(t) { return new (t || BmeiLicenseService)(); };
BmeiLicenseService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmeiLicenseService_Factory() { return new BmeiLicenseService(); }, token: BmeiLicenseService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmeiLicenseService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const Relationship = {
    OwnerOf: 'Owner of',
    LandlordOf: 'Landlord of',
};

class ExternalIntegrationComponent {
    constructor(contactService, licenseService, bmeiLicenseService, translateService) {
        this.contactService = contactService;
        this.licenseService = licenseService;
        this.bmeiLicenseService = bmeiLicenseService;
        this.translateService = translateService;
        this.getCompanyId = getCompanyId;
        this.noContactAlerts = [];
        this.iacModel = {
            hasOBAccountantView: false,
            hasIntegrationOB: false,
            hasQBcorrectIAC: false,
        };
    }
    /**
     * Updates the selected contact and set onbalance connect flag.
     * Called when it's changed in the combobox in ContactSelector
     */
    updateSelectedContact() {
        this.selectedContact = this.contactService.getSelectedContact();
        this.setShowOnbalanceConnectOptions();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentLocale = yield environment.getEnvironmentAsync();
            this.bmeiLicenseService.loadFrp();
            this.companyId = yield this.getCompanyId();
            this.licenseAgreementSigned = false;
            yield this.getIACFromSession();
            if (this.iacModel.hasIntegrationOB &&
                !this.iacModel.hasQBcorrectIAC &&
                this.currentLocale.countryCode === CountryCodes.UK) {
                this.contactService.getRelationships(this.companyId, this.ownerId).subscribe(relationships => {
                    const filteredRelationshipContacts = relationships
                        .filter(c => c.relationshipSide.name === Relationship.OwnerOf || c.relationshipSide.name === Relationship.LandlordOf)
                        .map(c => c.contactExpanded);
                    if (filteredRelationshipContacts.length > 0) {
                        this.contactService.setSelectedContact(filteredRelationshipContacts[0]);
                        this.relationshipContacts = filteredRelationshipContacts;
                        this.contacts = filteredRelationshipContacts;
                    }
                    else {
                        this.noContactAlerts.push({
                            type: 'info',
                            msg: this.translateService.instant('bmei.integration.noContactMessage'),
                            closeable: true,
                        });
                    }
                });
            }
            else {
                this.contactService.loadRelatedContacts(this.companyId, this.ownerId).subscribe(contacts => {
                    const ownerContact = contacts.find(contact => {
                        return contact.id === this.ownerId;
                    });
                    this.contactService.setSelectedContact(ownerContact);
                    if (!this.showContactDropdown) {
                        this.selectedContact = ownerContact;
                    }
                    this.contacts = contacts;
                    if (this.contacts.length === 0) {
                        this.noContactAlerts.push({
                            type: 'info',
                            msg: this.translateService.instant('bmei.integration.noContactMessage'),
                            closeable: true,
                        });
                    }
                });
                if (this.iacModel.hasIntegrationOB && this.currentLocale.countryCode === CountryCodes.UK) {
                    this.contactService.getRelationships(this.companyId, this.ownerId).subscribe(relationships => {
                        if (relationships.length > 0) {
                            this.relationshipContacts = relationships
                                .filter(c => c.relationshipSide.name === Relationship.OwnerOf || c.relationshipSide.name === Relationship.LandlordOf)
                                .map(c => c.contactExpanded);
                        }
                    });
                }
            }
            // lets set the licenseAgreementSigned value
            this.licenseService.getAcceptedLicenseAgreement(this.companyId).subscribe(licenseAgreement => {
                if (licenseAgreement && licenseAgreement.agreeingEntityId === this.companyId) {
                    this.licenseAgreementSigned = true;
                }
            }, () => {
                this.licenseAgreementSigned = false;
            });
        });
    }
    /**
     * Gets the available IACs from the session call, based on the that map the boolean flag to the respective IAC property from model
     * @returns IAC model
     */
    getIACFromSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const iacList = yield session.getIACsWithFallback();
            this.iacModel.hasOBAccountantView = iacList.includes(IAC.OnBalanceAccountantView);
            this.iacModel.hasIntegrationOB = iacList.includes(IAC.IntegrationOB);
            this.iacModel.hasQBcorrectIAC =
                iacList.includes(IAC.IntegrationQBO) ||
                    iacList.includes(IAC.WorkpapersIntegrationQB) ||
                    iacList.includes(IAC.TrialBalanceIntegrationQB);
            return this.iacModel;
        });
    }
    /**
     * Check on providing QB IACs and contacts info
     * @returns boolean for displaying integration component
     */
    showQBIntegration() {
        return this.contacts !== undefined && this.iacModel.hasQBcorrectIAC;
    }
    /**
     * Check on providing OB IACs and contacts info
     * @returns boolean for displaying integration component
     */
    showOBIntegration() {
        return (this.showContactDropdown &&
            this.clientId !== undefined &&
            this.iacModel.hasIntegrationOB &&
            this.bmeiLicenseService.hasOnBalanceLinkingLicense);
    }
    /**
     * Check selected client entity type when accountsOB IAC presented
     * @returns boolean of entity type checking result
     */
    isValidClientEntityType() {
        return this.clientEntityTypeId === EntityType.GBINDIVIDUAL;
    }
    /**
     * Check selected contact is one of the expected relationships
     * @returns whether the select contact has correct relationship
     */
    isValidRelationship() {
        var _a;
        return (_a = this.relationshipContacts) === null || _a === void 0 ? void 0 : _a.some(r => { var _a; return r.id === ((_a = this.selectedContact) === null || _a === void 0 ? void 0 : _a.id); });
    }
    /**
     * Set the show onbalance connect flag for non-UK or UK with valid conditions.
     * It will be set if it is valid client entity type and valid selected contact relationship.
     */
    setShowOnbalanceConnectOptions() {
        this.showOnbalanceConnectOptions =
            this.currentLocale.countryCode !== CountryCodes.UK ||
                (this.currentLocale.countryCode === CountryCodes.UK && this.isValidClientEntityType() && this.isValidRelationship());
    }
}
ExternalIntegrationComponent.ɵfac = function ExternalIntegrationComponent_Factory(t) { return new (t || ExternalIntegrationComponent)(ɵngcc0.ɵɵdirectiveInject(BmeiContactService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LicenseAgreementService), ɵngcc0.ɵɵdirectiveInject(BmeiLicenseService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService)); };
ExternalIntegrationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ExternalIntegrationComponent, selectors: [["bmei-external-integration"]], inputs: { clientId: "clientId", ownerId: "ownerId", clientEntityTypeId: "clientEntityTypeId", showContactDropdown: "showContactDropdown" }, decls: 6, vars: 5, consts: [[1, "bmei-external-wrapper"], ["class", "bmei-external-header", 4, "ngIf"], [3, "items", 4, "ngIf"], [3, "contacts", "selectedContactChanged", 4, "ngIf"], [3, "selectedContact", "licenseAgreementSigned", 4, "ngIf"], [3, "iacModel", "selectedContact", "showOnbalanceConnectOptions", "clientId", "companyId", 4, "ngIf"], [1, "bmei-external-header"], [3, "items"], [3, "contacts", "selectedContactChanged"], [3, "selectedContact", "licenseAgreementSigned"], [3, "iacModel", "selectedContact", "showOnbalanceConnectOptions", "clientId", "companyId"]], template: function ExternalIntegrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ExternalIntegrationComponent_h3_1_Template, 3, 3, "h3", 1);
        ɵngcc0.ɵɵtemplate(2, ExternalIntegrationComponent_bento_alert_2_Template, 1, 1, "bento-alert", 2);
        ɵngcc0.ɵɵtemplate(3, ExternalIntegrationComponent_bmei_contact_selector_3_Template, 1, 1, "bmei-contact-selector", 3);
        ɵngcc0.ɵɵtemplate(4, ExternalIntegrationComponent_bmei_quick_books_integration_component_4_Template, 1, 2, "bmei-quick-books-integration-component", 4);
        ɵngcc0.ɵɵtemplate(5, ExternalIntegrationComponent_bmei_onbalance_integration_component_5_Template, 1, 5, "bmei-onbalance-integration-component", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOBIntegration());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.noContactAlerts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showContactDropdown && ctx.contacts !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showQBIntegration());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOBIntegration());
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc5.BentoAlertComponent, ContactSelectorComponent, QuickBooksIntegrationComponent, OnbalanceIntegrationComponent]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, styles: [".bmei-external-wrapper[_ngcontent-%COMP%]{margin:10px}.bmei-external-header[_ngcontent-%COMP%]{margin-bottom:20px}"] });
ExternalIntegrationComponent.ctorParameters = () => [
    { type: BmeiContactService },
    { type: LicenseAgreementService },
    { type: BmeiLicenseService },
    { type: TranslateService }
];
ExternalIntegrationComponent.propDecorators = {
    clientId: [{ type: Input }],
    ownerId: [{ type: Input }],
    clientEntityTypeId: [{ type: Input }],
    showContactDropdown: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExternalIntegrationComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-external-integration',
                template: "<div class=\"bmei-external-wrapper\">\n\t<h3 class=\"bmei-external-header\" *ngIf=\"this.showOBIntegration()\">{{'bmei.integration.integration' | translate}}</h3>\n\t<bento-alert *ngIf=\"noContactAlerts\" [items]=\"noContactAlerts\"></bento-alert>\n\t<bmei-contact-selector\n\t\t*ngIf=\"showContactDropdown && contacts !== undefined\"\n\t\t[contacts]=\"contacts\"\n\t\t(selectedContactChanged)=\"updateSelectedContact()\"\n\t></bmei-contact-selector>\n\t<bmei-quick-books-integration-component\n\t\t*ngIf=\"this.showQBIntegration()\"\n\t\t[selectedContact]=\"selectedContact\"\n\t\t[licenseAgreementSigned]=\"licenseAgreementSigned\"\n\t></bmei-quick-books-integration-component>\n\t<bmei-onbalance-integration-component\n\t\t*ngIf=\"this.showOBIntegration()\"\n\t\t[iacModel]=\"iacModel\"\n\t\t[selectedContact]=\"selectedContact\"\n\t\t[showOnbalanceConnectOptions]=\"showOnbalanceConnectOptions\"\n\t\t[clientId]=\"clientId\"\n\t\t[companyId]=\"companyId\"\n\t></bmei-onbalance-integration-component>\n</div>\n",
                styles: [".bmei-external-wrapper{margin:10px}.bmei-external-header{margin-bottom:20px}"]
            }]
    }], function () { return [{ type: BmeiContactService }, { type: ɵngcc2.LicenseAgreementService }, { type: BmeiLicenseService }, { type: ɵngcc3.TranslateService }]; }, { clientId: [{
            type: Input
        }], ownerId: [{
            type: Input
        }], clientEntityTypeId: [{
            type: Input
        }], showContactDropdown: [{
            type: Input
        }] }); })();

class QuickBooksIntegrationCallbackComponent {
    constructor(requestGrantService) {
        this.requestGrantService = requestGrantService;
    }
    getWindowUrl() {
        return new URL(window.location.href);
    }
    ngOnInit() {
        const url = this.getWindowUrl();
        const urlSearchParams = url.searchParams;
        const state = urlSearchParams.get('state');
        const code = urlSearchParams.get('code');
        const realmId = urlSearchParams.get('realmId');
        this.requestGrantService
            .getGrantToken({ encryptedRealmId: realmId, authorizationCode: code, linkSessionId: state })
            .subscribe(() => {
            this.isSuccess = true;
        }, () => {
            this.isSuccess = false;
        });
    }
}
QuickBooksIntegrationCallbackComponent.ɵfac = function QuickBooksIntegrationCallbackComponent_Factory(t) { return new (t || QuickBooksIntegrationCallbackComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.RequestGrantService)); };
QuickBooksIntegrationCallbackComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: QuickBooksIntegrationCallbackComponent, selectors: [["bmei-quick-books-integration-callback"]], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "bmei-qbo-message-header"], [1, "bmei-qbo-message-split"], [1, "bmei-qbo-message-body"]], template: function QuickBooksIntegrationCallbackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, QuickBooksIntegrationCallbackComponent_div_0_Template, 8, 6, "div", 0);
        ɵngcc0.ɵɵtemplate(1, QuickBooksIntegrationCallbackComponent_div_1_Template, 8, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSuccess);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSuccess === false);
    } }, directives: [ɵngcc4.NgIf], pipes: [ɵngcc3.TranslatePipe], styles: [".bmei-qbo-message-header[_ngcontent-%COMP%]{margin-top:0;line-height:35px;font-weight:700;color:#000;padding:15px}.bmei-qbo-message-body[_ngcontent-%COMP%]{padding:15px;display:block}.bmei-qbo-message-split[_ngcontent-%COMP%]{color:grey;margin:0 15}"] });
QuickBooksIntegrationCallbackComponent.ctorParameters = () => [
    { type: RequestGrantService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QuickBooksIntegrationCallbackComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-quick-books-integration-callback',
                template: "<div *ngIf=\"isSuccess\">\n\t<h1 class=\"bmei-qbo-message-header\">{{'bmei.qbo.success' | translate}}</h1>\n\t<hr class=\"bmei-qbo-message-split\" />\n\t<span class=\"bmei-qbo-message-body\">{{'bmei.qbo.successMessage' | translate}}</span>\n</div>\n<div *ngIf=\"isSuccess === false\">\n\t<h1 class=\"bmei-qbo-message-header\">{{'bmei.qbo.failure' | translate}}</h1>\n\t<hr class=\"bmei-qbo-message-split\" />\n\t<span class=\"bmei-qbo-message-body\">{{'bmei.qbo.failureMessage' | translate}}</span>\n</div>\n",
                styles: [".bmei-qbo-message-header{margin-top:0;line-height:35px;font-weight:700;color:#000;padding:15px}.bmei-qbo-message-body{padding:15px;display:block}.bmei-qbo-message-split{color:grey;margin:0 15}"]
            }]
    }], function () { return [{ type: ɵngcc2.RequestGrantService }]; }, null); })();

class ContactSelectorComponent {
    constructor(contactService) {
        this.contactService = contactService;
        this.selectedContactChanged = new EventEmitter();
    }
    get selectedContact() {
        return this._selectedContact;
    }
    set selectedContact(contact) {
        this._selectedContact = contact;
        this.contactService.setSelectedContact(contact);
        this.selectedContactChanged.emit();
    }
    ngOnInit() {
        this.selectedContact = this.contactService.getSelectedContact();
    }
}
ContactSelectorComponent.ɵfac = function ContactSelectorComponent_Factory(t) { return new (t || ContactSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(BmeiContactService)); };
ContactSelectorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ContactSelectorComponent, selectors: [["bmei-contact-selector"]], inputs: { contacts: "contacts" }, outputs: { selectedContactChanged: "selectedContactChanged" }, decls: 8, vars: 4, consts: [[1, "row"], [1, "col-md-12"], [1, "col-md-6"], ["id", "contactSelectorCombobox", "bentoSelect", "", "attr.data-qe-id", "bmei.contactSelectorCombobox", "class", "form-control", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["id", "contactSelectorCombobox", "bentoSelect", "", "attr.data-qe-id", "bmei.contactSelectorCombobox", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function ContactSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(5, "div", 0)(6, "div", 2);
        ɵngcc0.ɵɵtemplate(7, ContactSelectorComponent_select_7_Template, 2, 2, "select", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "bmei.integration.integrationFor"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contacts);
    } }, directives: [ɵngcc4.NgIf, ɵngcc5.BentoSelectDirective, ɵngcc6.SelectControlValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.NgForOf, ɵngcc6.NgSelectOption, ɵngcc6.ɵNgSelectMultipleOption], pipes: [ɵngcc3.TranslatePipe], styles: [".bento-select[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{background:#fff!important}.bento-select[_ngcontent-%COMP%]   .btn-icon[_ngcontent-%COMP%]{z-index:2}"] });
ContactSelectorComponent.ctorParameters = () => [
    { type: BmeiContactService }
];
ContactSelectorComponent.propDecorators = {
    contacts: [{ type: Input }],
    selectedContactChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContactSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-contact-selector',
                template: "<div class=\"row\">\n\t<div class=\"col-md-12\">\n\t\t<span>{{ 'bmei.integration.integrationFor' | translate}}</span>\n\t</div>\n</div>\n<div class=\"row\">\n\t<div class=\"col-md-6\">\n\t\t<select\n\t\t\t*ngIf=\"contacts\"\n\t\t\tid=\"contactSelectorCombobox\"\n\t\t\tbentoSelect\n\t\t\tattr.data-qe-id=\"bmei.contactSelectorCombobox\"\n\t\t\tclass=\"form-control\"\n\t\t\t[(ngModel)]=\"selectedContact\"\n\t\t>\n\t\t\t<option *ngFor=\"let contact of contacts\" [ngValue]=\"contact\">{{contact.displayAs}}</option>\n\t\t</select>\n\t</div>\n</div>\n",
                styles: [".bento-select select{background:#fff!important}.bento-select .btn-icon{z-index:2}"]
            }]
    }], function () { return [{ type: BmeiContactService }]; }, { selectedContactChanged: [{
            type: Output
        }], contacts: [{
            type: Input
        }] }); })();

class LicenseAgreementModalComponent {
    constructor(activeModal, translateService, licenseService) {
        this.activeModal = activeModal;
        this.translateService = translateService;
        this.licenseService = licenseService;
        this.user = user;
        // this is by default false
        this.isLicenseAgreementChecked = false;
    }
    ngOnInit() {
        // setting  the software agreement depending on the language choosen
        this.licenseSrc = this.translateService.instant('bmei.qbo.licenseAgreement');
    }
    // close the modal
    close() {
        this.activeModal.dismiss();
    }
    // save the changes down for the checkbox
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentUser = yield this.getCurrentUser();
            // There's the potential for the names to be undefined. If so, we just want to include the names the user has
            let userName = `${currentUser.firstName ? currentUser.firstName : ''}`;
            userName += `${currentUser.firstName && currentUser.lastName ? ' ' : ''}`;
            userName += `${currentUser.lastName ? currentUser.lastName : ''}`;
            const licenseAgreementDTO = {
                agreeingEntityId: currentUser.companyId,
                agreedUserId: currentUser.blueID,
                agreedUserName: userName,
            };
            this.licenseService.saveAcceptedLicenseAgreement(licenseAgreementDTO).subscribe(() => {
                this.isLicenseAgreementChecked = true;
                this.activeModal.close();
            }, () => {
                this.isLicenseAgreementChecked = false;
                this.activeModal.close();
            });
        });
    }
    // cancel out the modal without saving any changes
    cancel() {
        this.activeModal.dismiss();
    }
    // they click the license agreement link, open the pdf page to view the agreement.
    openlicenseAgreement() {
        window.open(this.licenseSrc, 'licenseAgreement');
    }
    getCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.user.getCurrentUser();
        });
    }
}
LicenseAgreementModalComponent.ɵfac = function LicenseAgreementModalComponent_Factory(t) { return new (t || LicenseAgreementModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LicenseAgreementService)); };
LicenseAgreementModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LicenseAgreementModalComponent, selectors: [["bmei-license-agreement-modal"]], outputs: { isLicenseAgreementChecked: "isLicenseAgreementChecked" }, decls: 39, vars: 29, consts: [["type", "button", "aria-hidden", "true", "id", "bmei-license-agreement-x-button", 1, "close", 3, "click"], [1, "bento-icon-close-x"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "Close", "attr.data-qe-id", "bmei.qboLicenseHeaderCancel", 1, "close", 3, "click"], [1, "modal-body"], ["id", "bmei-license-agreement-link"], ["data-qe-id", "bmei.qboLicenseAgreementLink", 1, "bmei-fake-link", 3, "click"], ["id", "bmei-license-agreement-accept-terms"], ["id", "bmei-license-agreement-agreement-checkbox"], ["data-qe-id", "bmei.qboLicenseCheckbox", 1, "license-checkbox", 3, "ngModel", "ngModelChange"], ["for", "bmei-license-agreement-i-have-read"], ["data-qe-id", "bmei.qboLicenseAgreementLinkCheckbox", 1, "bmei-fake-link", 3, "click"], [1, "modal-footer"], ["type", "button", "id", "bmei-license-agreement-save", "data-qe-id", "bmei.qboLicenseAgreementSave", 1, "btn", "btn-primary", 3, "disabled", "click"], ["type", "button", "id", "bmei-license-agreement-cancel", "data-qe-id", "bmei.qboLicenseAgreementFooterCancel", 1, "btn", "btn-outline-primary", 3, "click"]], template: function LicenseAgreementModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "button", 0);
        ɵngcc0.ɵɵlistener("click", function LicenseAgreementModalComponent_Template_button_click_1_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelement(2, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2)(4, "h1", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 4);
        ɵngcc0.ɵɵlistener("click", function LicenseAgreementModalComponent_Template_button_click_7_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(8, "div", 5)(9, "div")(10, "p", 6);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵpipe(12, "translate");
        ɵngcc0.ɵɵelementStart(13, "span", 7);
        ɵngcc0.ɵɵlistener("click", function LicenseAgreementModalComponent_Template_span_click_13_listener() { return ctx.openlicenseAgreement(); });
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(16, "p", 8);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(19, "br")(20, "br")(21, "br");
        ɵngcc0.ɵɵelementStart(22, "div", 9)(23, "bento-checkbox", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function LicenseAgreementModalComponent_Template_bento_checkbox_ngModelChange_23_listener($event) { return ctx.isLicenseAgreementChecked = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "label", 11);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementStart(27, "span", 12);
        ɵngcc0.ɵɵlistener("click", function LicenseAgreementModalComponent_Template_span_click_27_listener() { return ctx.openlicenseAgreement(); });
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵpipe(31, "translate");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(32, "div", 13)(33, "button", 14);
        ɵngcc0.ɵɵlistener("click", function LicenseAgreementModalComponent_Template_button_click_33_listener() { return ctx.save(); });
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "button", 15);
        ɵngcc0.ɵɵlistener("click", function LicenseAgreementModalComponent_Template_button_click_36_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(37);
        ɵngcc0.ɵɵpipe(38, "translate");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 11, "bmei.qbo.license"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(12, 13, "bmei.qbo.reviewLicense"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(15, 15, "bmei.qbo.licenceAgreement"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(18, 17, "bmei.qbo.acceptTerms"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.isLicenseAgreementChecked);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(26, 19, "bmei.qbo.iHaveRead"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(29, 21, "bmei.qbo.licensingAgreement"), "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(31, 23, "bmei.qbo.agreeTerms"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", !ctx.isLicenseAgreementChecked);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(35, 25, "bmei.integration.save"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(38, 27, "bmei.integration.cancel"), " ");
    } }, directives: [ɵngcc5.BentoFocusMonitorDirective, ɵngcc5.BentoCheckboxComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc5.BentoFooterTabHelper], pipes: [ɵngcc3.TranslatePipe], styles: ["#bmei-license-agreement-text[_ngcontent-%COMP%]{font-family:BentoRegular,arial,helvetica,sans-serif;font-size:16px;line-height:1.5;margin-bottom:20px}.license-checkbox[_ngcontent-%COMP%]{opacity:none}.bmei-fake-link[_ngcontent-%COMP%]{color:#00f;text-decoration:underline;cursor:pointer}"] });
LicenseAgreementModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: TranslateService },
    { type: LicenseAgreementService }
];
LicenseAgreementModalComponent.propDecorators = {
    isLicenseAgreementChecked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LicenseAgreementModalComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-license-agreement-modal',
                template: "<div>\n\t<button type=\"button\" class=\"close\" aria-hidden=\"true\" (click)=\"cancel()\" id=\"bmei-license-agreement-x-button\">\n\t\t<i class=\"bento-icon-close-x\"></i>\n\t</button>\n\t<div class=\"modal-header\">\n\t\t<h1 class=\"modal-title\">{{'bmei.qbo.license' | translate}}</h1>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"close\"\n\t\t\taria-label=\"Close\"\n\t\t\tattr.data-qe-id=\"bmei.qboLicenseHeaderCancel\"\n\t\t\t(click)=\"cancel()\"\n\t\t></button>\n\t</div>\n\t<div class=\"modal-body\">\n\t\t<div>\n\t\t\t<p id=\"bmei-license-agreement-link\">\n\t\t\t\t{{'bmei.qbo.reviewLicense' | translate}}\n\t\t\t\t<span class=\"bmei-fake-link\" (click)=\"openlicenseAgreement()\" data-qe-id=\"bmei.qboLicenseAgreementLink\">\n\t\t\t\t\t{{'bmei.qbo.licenceAgreement' | translate}}\n\t\t\t\t</span>\n\t\t\t</p>\n\t\t\t<p id=\"bmei-license-agreement-accept-terms\">{{'bmei.qbo.acceptTerms' | translate}}</p>\n\t\t</div>\n\t\t<br />\n\t\t<br />\n\t\t<br />\n\t\t<div id=\"bmei-license-agreement-agreement-checkbox\">\n\t\t\t<bento-checkbox\n\t\t\t\tclass=\"license-checkbox\"\n\t\t\t\tdata-qe-id=\"bmei.qboLicenseCheckbox\"\n\t\t\t\t[(ngModel)]=\"isLicenseAgreementChecked\"\n\t\t\t></bento-checkbox>\n\t\t\t<label for=\"bmei-license-agreement-i-have-read\"\n\t\t\t\t>{{'bmei.qbo.iHaveRead' | translate}}\n\t\t\t\t<span class=\"bmei-fake-link\" (click)=\"openlicenseAgreement()\" data-qe-id=\"bmei.qboLicenseAgreementLinkCheckbox\">\n\t\t\t\t\t{{'bmei.qbo.licensingAgreement' | translate}}</span\n\t\t\t\t>\n\t\t\t\t{{'bmei.qbo.agreeTerms' | translate}}\n\t\t\t</label>\n\t\t</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\t[disabled]=\"!isLicenseAgreementChecked\"\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\tid=\"bmei-license-agreement-save\"\n\t\t\t(click)=\"save()\"\n\t\t\tdata-qe-id=\"bmei.qboLicenseAgreementSave\"\n\t\t>\n\t\t\t{{'bmei.integration.save' | translate}}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\tid=\"bmei-license-agreement-cancel\"\n\t\t\t(click)=\"cancel()\"\n\t\t\tdata-qe-id=\"bmei.qboLicenseAgreementFooterCancel\"\n\t\t>\n\t\t\t{{'bmei.integration.cancel' | translate}}\n\t\t</button>\n\t</div>\n</div>\n",
                styles: ["#bmei-license-agreement-text{font-family:BentoRegular,arial,helvetica,sans-serif;font-size:16px;line-height:1.5;margin-bottom:20px}.license-checkbox{opacity:none}.bmei-fake-link{color:#00f;text-decoration:underline;cursor:pointer}"]
            }]
    }], function () { return [{ type: ɵngcc7.NgbActiveModal }, { type: ɵngcc3.TranslateService }, { type: ɵngcc2.LicenseAgreementService }]; }, { isLicenseAgreementChecked: [{
            type: Output
        }] }); })();

class ApplicationIdConstants {
}
ApplicationIdConstants.ACS_APPLICATION_ID = 'ACCOUNTING_CS';
ApplicationIdConstants.ONVIO_APPLICATION_ID = 'ONVIO';

class QboDisconnectModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    confirm() {
        this.activeModal.close();
    }
    cancel() {
        this.activeModal.dismiss();
    }
}
QboDisconnectModalComponent.ɵfac = function QboDisconnectModalComponent_Factory(t) { return new (t || QboDisconnectModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgbActiveModal)); };
QboDisconnectModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: QboDisconnectModalComponent, selectors: [["bmei-qbo-disconnect-modal"]], decls: 14, vars: 9, consts: [[1, "modal-body", "modal-confirm-body"], [1, "bento-icon-warning", "bmei-modal-confirm-icon"], [1, "modal-footer"], ["type", "button", "data-qe-id", "bmei.qboDisconnectModalConfirm", "id", "bmei-disconnect-confirm", 1, "btn", "btn-primary", 3, "click"], ["type", "button", "id", "bmei-disconnect-cancel", "data-qe-id", "bmei.qboDisconnectModalCancel", 1, "btn", "btn-outline-primary", 3, "click"]], template: function QboDisconnectModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "span");
        ɵngcc0.ɵɵelement(3, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 2)(8, "button", 3);
        ɵngcc0.ɵɵlistener("click", function QboDisconnectModalComponent_Template_button_click_8_listener() { return ctx.confirm(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 4);
        ɵngcc0.ɵɵlistener("click", function QboDisconnectModalComponent_Template_button_click_11_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 3, "bmei.qbo.disconnectWarning"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 5, "bmei.integration.disconnect"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 7, "bmei.integration.cancel"), " ");
    } }, directives: [ɵngcc5.BentoFooterTabHelper, ɵngcc5.BentoFocusMonitorDirective], pipes: [ɵngcc3.TranslatePipe], styles: [".bmei-modal-confirm-icon[_ngcontent-%COMP%]{color:red;padding-right:4px}"] });
QboDisconnectModalComponent.ctorParameters = () => [
    { type: NgbActiveModal }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QboDisconnectModalComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-qbo-disconnect-modal',
                template: "<div>\n\t<div class=\"modal-body modal-confirm-body\">\n\t\t<span><i class=\"bento-icon-warning bmei-modal-confirm-icon\"></i></span>\n\t\t<span>{{'bmei.qbo.disconnectWarning' | translate}}</span>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\tdata-qe-id=\"bmei.qboDisconnectModalConfirm\"\n\t\t\tid=\"bmei-disconnect-confirm\"\n\t\t\t(click)=\"confirm()\"\n\t\t>\n\t\t\t{{'bmei.integration.disconnect' | translate}}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\tid=\"bmei-disconnect-cancel\"\n\t\t\tdata-qe-id=\"bmei.qboDisconnectModalCancel\"\n\t\t\t(click)=\"cancel()\"\n\t\t>\n\t\t\t{{'bmei.integration.cancel' | translate}}\n\t\t</button>\n\t</div>\n</div>\n",
                styles: [".bmei-modal-confirm-icon{color:red;padding-right:4px}"]
            }]
    }], function () { return [{ type: ɵngcc7.NgbActiveModal }]; }, null); })();

// We're ok with the catches in this file using empty arrow functions
class QuickBooksIntegrationComponent {
    constructor(translateService, qboService, modalService, accessTokenService, requestGrantService, qboCompanyInfoService) {
        this.translateService = translateService;
        this.qboService = qboService;
        this.modalService = modalService;
        this.accessTokenService = accessTokenService;
        this.requestGrantService = requestGrantService;
        this.qboCompanyInfoService = qboCompanyInfoService;
    }
    get selectedContact() {
        return this._selectedContact;
    }
    set selectedContact(contact) {
        this._selectedContact = contact;
        // every time we change the contact, we want to check for QBO Access
        this.updateAccessToken();
    }
    ngOnInit() {
        this.connectToQuickBooksImageSource = this.translateService.instant('bmei.qbo.connectToQuickBooks');
    }
    getWindowOrigin() {
        return window.location.origin;
    }
    getWindowPathname() {
        return window.location.pathname;
    }
    getWindowInnerHeight() {
        return window.innerHeight;
    }
    getWindowInnerWidth() {
        return window.innerWidth;
    }
    openUrlInNewWindow(url, target, features) {
        window.open(url, target, features);
    }
    createRedirectUrl() {
        const host = this.getWindowOrigin();
        if (host.includes('local')) {
            return 'https://ci.onvio.us/staff';
        }
        return this.getWindowOrigin() + '/staff';
    }
    buildQboUrl(linkSessionId, clientId) {
        let qboUrl = `https://appcenter.intuit.com/connect/oauth2?client_id=${clientId}&scope=com.intuit.quickbooks.accounting`;
        qboUrl += `&redirect_uri=${this.createRedirectUrl()}&response_type=code&state=${linkSessionId}`;
        this.openUrlInNewWindow(qboUrl, '_blank', `menubar=no,height=${this.getWindowInnerHeight() * 0.667},width=${this.getWindowInnerWidth() * 0.667}`);
    }
    openQboAuth() {
        const linkSessionParamaters = {
            supportedApplicationId: ApplicationIdConstants.ONVIO_APPLICATION_ID,
            applicationQboEntityId: this.selectedContact.id,
        };
        this.qboService.generateLinkSessionId(linkSessionParamaters).subscribe(response => {
            if (response.linkSessionId !== undefined && response.qboOAuth2ClientId !== undefined) {
                this.buildQboUrl(response.linkSessionId, response.qboOAuth2ClientId);
            }
        }, () => { });
    }
    openLicenseModal() {
        const modalRef = this.modalService.open(LicenseAgreementModalComponent, {
            backdrop: 'static',
            keyboard: false,
            container: '#bentoNGModalContainer',
        });
        modalRef.result
            .then(() => {
            this.openQboAuth();
        })
            .catch(() => { });
    }
    // start the connect process if we hve the licenseAgreement is already signed
    startConnectProcess() {
        // if the license agreement is signed then we will open the QBO auth process if not we will
        // show the licnese Agrement model to sign.
        if (this.licenseAgreementSigned) {
            this.openQboAuth();
        }
        else {
            this.openLicenseModal();
        }
    }
    // validateAccessToken returns 200 if an access token can be produced for QBO interaction, meaning contact is linked
    updateAccessToken() {
        this.isLoading = true;
        this.accessTokenService
            .validateAccessToken(ApplicationIdConstants.ONVIO_APPLICATION_ID, this.selectedContact.id)
            .subscribe(() => {
            this.getCompanyName();
            this.linkedToQbo = true;
        }, () => {
            this.isLoading = false;
            this.linkedToQbo = false;
        });
    }
    // If getQboCompanyInfo returns success reponse, then capturing company name from reponse, if it fails we are setting the company name as empty.
    // This method will return connected(linked) company name.
    getCompanyName() {
        this.qboCompanyInfoService
            .getQboCompanyInfo(ApplicationIdConstants.ONVIO_APPLICATION_ID, this.selectedContact.id)
            .subscribe(response => {
            this.qboCompanyName = response.qboCompanyName;
            this.isLoading = false;
        }, () => {
            this.qboCompanyName = '';
            this.isLoading = false;
        });
    }
    disconnectQboClient() {
        this.requestGrantService.revokeGrant(ApplicationIdConstants.ONVIO_APPLICATION_ID, this.selectedContact.id).subscribe(() => {
            this.updateAccessToken();
        }, () => { });
    }
    openDisconnectModal() {
        const modalRef = this.modalService.open(QboDisconnectModalComponent, {
            backdrop: 'static',
            keyboard: false,
            container: '#bentoNGModalContainer',
        });
        modalRef.result
            .then(() => {
            this.disconnectQboClient();
        })
            .catch(() => { });
    }
}
QuickBooksIntegrationComponent.ɵfac = function QuickBooksIntegrationComponent_Factory(t) { return new (t || QuickBooksIntegrationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LinkSessionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.AccessTokenService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.RequestGrantService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.QuickbooksReportDataService)); };
QuickBooksIntegrationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: QuickBooksIntegrationComponent, selectors: [["bmei-quick-books-integration-component"]], inputs: { selectedContact: "selectedContact", licenseAgreementSigned: "licenseAgreementSigned" }, decls: 7, vars: 6, consts: [[1, "bmei-card-wrapper"], [1, "card", 3, "bentoBusyLoader"], [1, "card-header"], ["class", "card-body", 4, "ngIf"], [1, "card-body"], ["src", "assets/external-integration/img/qbo-logo.png", "alt", "intuit QuickBooks", "aria-label", "intuit QuickBooks", 1, "bmei-qbo-logo-img"], [1, "row"], [1, "col-md-6"], [1, "row", "bmei-bottom-padding"], [1, "bmei-bold-text"], [1, "col-md-5"], ["aria-hidden", "true"], ["id", "connectToQuickBooksButton", "translate", "bmei.qbo.connectToQuickBooksText", 1, "sr-only"], ["aria-labelledby", "connectToQuickBooksButton", "data-qe-id", "bmei.qboConnectToQuickbooks", "type", "image", 1, "bmei-qbo-logo-button", 3, "src", "click"], [1, "col-md-8"], ["data-qe-id", "bmei.qboDisconnectButton", 1, "btn", "btn-primary", 3, "click"]], template: function QuickBooksIntegrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, QuickBooksIntegrationComponent_div_5_Template, 17, 7, "div", 3);
        ɵngcc0.ɵɵtemplate(6, QuickBooksIntegrationComponent_div_6_Template, 17, 11, "div", 3);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isLoading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "bmei.qbo.integrationQbo"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.linkedToQbo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.linkedToQbo && ctx.qboCompanyName);
    } }, directives: [ɵngcc5.BentoBusyLoaderDirective, ɵngcc4.NgIf, ɵngcc3.TranslateDirective, ɵngcc5.BentoFocusMonitorDirective], pipes: [ɵngcc3.TranslatePipe], styles: [".bmei-card-wrapper{padding-top:10px}.bmei-bold-text{font-weight:700}.bmei-qbo-logo-button{height:2.857rem;max-width:100%;min-width:7.14285rem}.bmei-qbo-logo-img{height:6rem;width:22rem;float:right;top:6rem}.bmei-bottom-padding{padding-bottom:10px}bmei-external-integration .bento-busyloader-front-blocker{background:transparent!important}"], encapsulation: 2 });
QuickBooksIntegrationComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: LinkSessionService },
    { type: NgbModal },
    { type: AccessTokenService },
    { type: RequestGrantService },
    { type: QuickbooksReportDataService }
];
QuickBooksIntegrationComponent.propDecorators = {
    selectedContact: [{ type: Input }],
    licenseAgreementSigned: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QuickBooksIntegrationComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-quick-books-integration-component',
                template: "<div class=\"bmei-card-wrapper\">\n\t<div class=\"card\" [bentoBusyLoader]=\"isLoading\">\n\t\t<div class=\"card-header\">{{ 'bmei.qbo.integrationQbo' | translate }}</div>\n\t\t<div class=\"card-body\" *ngIf=\"!linkedToQbo\">\n\t\t\t<img\n\t\t\t\tclass=\"bmei-qbo-logo-img\"\n\t\t\t\tsrc=\"assets/external-integration/img/qbo-logo.png\"\n\t\t\t\talt=\"intuit QuickBooks\"\n\t\t\t\taria-label=\"intuit QuickBooks\"\n\t\t\t/>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t<div>{{ 'bmei.integration.integrateWith' | translate }}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row bmei-bottom-padding\">\n\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t<div class=\"bmei-bold-text\">{{ 'bmei.qbo.quickbooksOnline' | translate }}</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-5\">\n\t\t\t\t\t<div aria-hidden=\"true\">\n\t\t\t\t\t\t<span id=\"connectToQuickBooksButton\" class=\"sr-only\" translate=\"bmei.qbo.connectToQuickBooksText\"></span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<input\n\t\t\t\t\t\taria-labelledby=\"connectToQuickBooksButton\"\n\t\t\t\t\t\t(click)=\"startConnectProcess()\"\n\t\t\t\t\t\tclass=\"bmei-qbo-logo-button\"\n\t\t\t\t\t\tdata-qe-id=\"bmei.qboConnectToQuickbooks\"\n\t\t\t\t\t\ttype=\"image\"\n\t\t\t\t\t\t[src]=\"connectToQuickBooksImageSource\"\n\t\t\t\t\t/>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"card-body\" *ngIf=\"linkedToQbo && qboCompanyName\">\n\t\t\t<img\n\t\t\t\tclass=\"bmei-qbo-logo-img\"\n\t\t\t\tsrc=\"assets/external-integration/img/qbo-logo.png\"\n\t\t\t\talt=\"intuit QuickBooks\"\n\t\t\t\taria-label=\"intuit QuickBooks\"\n\t\t\t/>\n\t\t\t<div class=\"row bmei-bottom-padding\">\n\t\t\t\t<div class=\"col-md-8\">\n\t\t\t\t\t{{ 'bmei.qbo.companyLinked1' | translate }}\n\t\t\t\t\t<span class=\"bmei-bold-text\">{{ qboCompanyName }}</span>\n\t\t\t\t\t{{ 'bmei.qbo.companyLinked2' | translate }}\n\t\t\t\t\t<span class=\"bmei-bold-text\">{{ ' ' + selectedContact.fullName }}</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t<button class=\"btn btn-primary\" (click)=\"openDisconnectModal()\" data-qe-id=\"bmei.qboDisconnectButton\">\n\t\t\t\t\t\t{{ 'bmei.integration.disconnect' | translate }}\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmei-card-wrapper{padding-top:10px}.bmei-bold-text{font-weight:700}.bmei-qbo-logo-button{height:2.857rem;max-width:100%;min-width:7.14285rem}.bmei-qbo-logo-img{height:6rem;width:22rem;float:right;top:6rem}.bmei-bottom-padding{padding-bottom:10px}bmei-external-integration .bento-busyloader-front-blocker{background:transparent!important}"]
            }]
    }], function () { return [{ type: ɵngcc3.TranslateService }, { type: ɵngcc2.LinkSessionService }, { type: ɵngcc7.NgbModal }, { type: ɵngcc2.AccessTokenService }, { type: ɵngcc2.RequestGrantService }, { type: ɵngcc2.QuickbooksReportDataService }]; }, { selectedContact: [{
            type: Input
        }], licenseAgreementSigned: [{
            type: Input
        }] }); })();

class IacModel {
    constructor() {
        this.hasOBAccountantView = false;
        this.hasIntegrationOB = false;
        this.hasQBcorrectIAC = false;
    }
}

class OnBalanceContact extends Contact {
}
class ContactEmail {
}

const PlanType = {
    SelfEmployed: 'Self-employed',
};

const validateEmailString = new RegExp("^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-" +
    '\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b' +
    '\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|' +
    '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-' +
    '\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-' +
    '\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|' +
    '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF' +
    '\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$', 'i');

class BmeiDateFormatterService {
    constructor(locale) {
        this.locale = locale.toLowerCase();
        this.formatter = new Intl.DateTimeFormat(locale, { year: 'numeric', month: '2-digit', day: '2-digit' });
    }
    /**
     * Formats date by users selected locale
     * @param dateString - Original date string or date object
     * @returns Formatted date string
     */
    formatDate(dateString) {
        if (dateString) {
            return this.formatter.format(new Date(dateString));
        }
    }
    /**
     * Get date format based on the current locale
     * @returns Date format
     */
    getFormat() {
        const formats = {
            'en-us': 'MM/dd/yyyy',
            'es-ar': 'dd/MM/yyyy',
            'fr-ca': 'yyyy-MM-dd',
            'en-ca': 'yyyy-MM-dd',
        };
        return formats[this.locale] || 'dd/MM/yyyy';
    }
}
BmeiDateFormatterService.ɵfac = function BmeiDateFormatterService_Factory(t) { return new (t || BmeiDateFormatterService)(ɵngcc0.ɵɵinject(LOCALE_ID)); };
BmeiDateFormatterService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BmeiDateFormatterService_Factory() { return new BmeiDateFormatterService(i0.ɵɵinject(i0.LOCALE_ID)); }, token: BmeiDateFormatterService, providedIn: "root" });
BmeiDateFormatterService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmeiDateFormatterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

class RequestPeriodModalComponent {
    constructor(activeModal, dateFormatter) {
        this.activeModal = activeModal;
        this.dateFormatter = dateFormatter;
        this.comboboxOptions = {
            searchable: false,
            labelFormatter: row => this.dateFormatter.formatDate(row.endDate),
        };
    }
    get fiscalYears() {
        return this.fiscalYears$;
    }
    set fiscalYears(years) {
        this.fiscalYears$ = years;
    }
    /**
     * Close modal, and send selected fiscal year, when user click 'request' button
     */
    onRequest() {
        this.activeModal.close(this.selectedFinancialYear);
    }
    /**
     * Close modal when user click 'cancel' button
     */
    onCancel() {
        this.activeModal.dismiss('cancel');
    }
    /**
     * Close modal when user click 'X'
     */
    onClose() {
        this.activeModal.dismiss('close');
    }
}
RequestPeriodModalComponent.ɵfac = function RequestPeriodModalComponent_Factory(t) { return new (t || RequestPeriodModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(BmeiDateFormatterService)); };
RequestPeriodModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RequestPeriodModalComponent, selectors: [["bmei-request-period-modal"]], inputs: { fiscalYears: "fiscalYears", contactName: "contactName" }, decls: 27, vars: 24, consts: [[1, "modal-header"], ["type", "button", "aria-hidden", "true", "data-qe-id", "bmei-ob-prior-data-button-close", 1, "close", "bmei-modal-close-button", 3, "click"], [1, "bento-icon-close-x"], [1, "modal-body"], [1, "row"], [1, "col-md-12", "col-sm-12", "col-xs-12", "form-group"], [1, "control-label", "inline"], [1, "col-md-6", "col-sm-6", "col-xs-6", "form-group", "bmei-ob-modal-combobox-container"], ["attr.data-qe-id", "bmei.ob.financialYear.combobox", 1, "bmei-ob-modal-combobox", 3, "itemsObservable", "ngModel", "appendTo", "options", "rowTemplate", "ngModelChange"], ["comboboxItem", ""], [1, "modal-footer"], ["data-qe-id", "bmei-ob-prior-data-button-request", 1, "btn", "btn-primary", 3, "disabled", "click"], ["data-qe-id", "bmei-ob-prior-data-button-cancel", 1, "btn", "btn-default", 3, "click"]], template: function RequestPeriodModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "span");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 1);
        ɵngcc0.ɵɵlistener("click", function RequestPeriodModalComponent_Template_button_click_4_listener() { return ctx.onClose(); });
        ɵngcc0.ɵɵelement(5, "i", 2);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(6, "div", 3)(7, "div", 4)(8, "div", 5)(9, "label", 6);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵpipe(11, "translate");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(12, "div", 4)(13, "div", 7)(14, "label", 6);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵpipe(16, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "bento-combobox", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function RequestPeriodModalComponent_Template_bento_combobox_ngModelChange_17_listener($event) { return ctx.selectedFinancialYear = $event; });
        ɵngcc0.ɵɵtemplate(18, RequestPeriodModalComponent_ng_template_18_Template, 2, 1, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(20, "div", 10)(21, "button", 11);
        ɵngcc0.ɵɵlistener("click", function RequestPeriodModalComponent_Template_button_click_21_listener() { return ctx.onRequest(); });
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵpipe(23, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "button", 12);
        ɵngcc0.ɵɵlistener("click", function RequestPeriodModalComponent_Template_button_click_24_listener() { return ctx.onCancel(); });
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵpipe(26, "translate");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(19);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(3, 11, "bmei.ob.requestPriorPeriod.modalHeader", ɵngcc0.ɵɵpureFunction1(22, _c0, ctx.contactName)));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 14, "bmei.ob.requestPriorPeriod.modalText"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 16, "bmei.ob.requestPriorPeriod.selectFinancialYearLabel"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("itemsObservable", ctx.fiscalYears$)("ngModel", ctx.selectedFinancialYear)("appendTo", ".bmei-ob-modal-combobox-container")("options", ctx.comboboxOptions)("rowTemplate", _r0);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", !ctx.selectedFinancialYear);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(23, 18, "bmei.ob.requestPriorPeriod.request"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(26, 20, "bmei.ob.requestPriorPeriod.cancel"), " ");
    } }, directives: [ɵngcc5.BentoFocusMonitorDirective, ɵngcc5.BentoComboboxComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc5.BentoFooterTabHelper], pipes: [ɵngcc3.TranslatePipe], styles: ["button.bmei-modal-close-button{padding-top:21px!important;font-size:medium!important}bento-combobox.bmei-ob-modal-combobox input{background-color:#fff!important;border:1px solid #939393!important}"], encapsulation: 2 });
RequestPeriodModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: BmeiDateFormatterService }
];
RequestPeriodModalComponent.propDecorators = {
    fiscalYears: [{ type: Input }],
    contactName: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RequestPeriodModalComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-request-period-modal',
                template: "<div class=\"modal-header\">\n\t<span>{{ 'bmei.ob.requestPriorPeriod.modalHeader' | translate: { contactName: contactName} }}</span>\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close bmei-modal-close-button\"\n\t\taria-hidden=\"true\"\n\t\tdata-qe-id=\"bmei-ob-prior-data-button-close\"\n\t\t(click)=\"onClose()\"\n\t>\n\t\t<i class=\"bento-icon-close-x\"></i>\n\t</button>\n</div>\n<div class=\"modal-body\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-12 col-sm-12 col-xs-12 form-group\">\n\t\t\t<label class=\"control-label inline\"> {{'bmei.ob.requestPriorPeriod.modalText' | translate}} </label>\n\t\t</div>\n\t</div>\n\t<div class=\"row\">\n\t\t<div class=\"col-md-6 col-sm-6 col-xs-6 form-group bmei-ob-modal-combobox-container\">\n\t\t\t<label class=\"control-label inline\"> {{'bmei.ob.requestPriorPeriod.selectFinancialYearLabel' | translate}} </label>\n\t\t\t<bento-combobox\n\t\t\t\tclass=\"bmei-ob-modal-combobox\"\n\t\t\t\tattr.data-qe-id=\"bmei.ob.financialYear.combobox\"\n\t\t\t\t[itemsObservable]=\"fiscalYears$\"\n\t\t\t\t[(ngModel)]=\"selectedFinancialYear\"\n\t\t\t\t[appendTo]=\"'.bmei-ob-modal-combobox-container'\"\n\t\t\t\t[options]=\"comboboxOptions\"\n\t\t\t\t[rowTemplate]=\"comboboxItem\"\n\t\t\t>\n\t\t\t\t<ng-template #comboboxItem let-$data=\"data\">\n\t\t\t\t\t<span>{{ this.dateFormatter.formatDate($data.row.endDate)}}</span>\n\t\t\t\t</ng-template>\n\t\t\t</bento-combobox>\n\t\t</div>\n\t</div>\n</div>\n<div class=\"modal-footer\">\n\t<button\n\t\tclass=\"btn btn-primary\"\n\t\tdata-qe-id=\"bmei-ob-prior-data-button-request\"\n\t\t[disabled]=\"!selectedFinancialYear\"\n\t\t(click)=\"onRequest()\"\n\t>\n\t\t{{'bmei.ob.requestPriorPeriod.request' | translate}}\n\t</button>\n\t<button class=\"btn btn-default\" data-qe-id=\"bmei-ob-prior-data-button-cancel\" (click)=\"onCancel()\">\n\t\t{{'bmei.ob.requestPriorPeriod.cancel' | translate}}\n\t</button>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["button.bmei-modal-close-button{padding-top:21px!important;font-size:medium!important}bento-combobox.bmei-ob-modal-combobox input{background-color:#fff!important;border:1px solid #939393!important}"]
            }]
    }], function () { return [{ type: ɵngcc7.NgbActiveModal }, { type: BmeiDateFormatterService }]; }, { fiscalYears: [{
            type: Input
        }], contactName: [{
            type: Input
        }] }); })();

const priorPeriodRequestReason = 'Accountant Requested';

class OnbalanceIntegrationComponent {
    constructor(translateService, registrationService, smbCenterSambaCompanyService, companyService, productsService, dateFormatter, confirmationService, ngbModalService, fiscalYearService, bmeiLicenseService) {
        this.translateService = translateService;
        this.registrationService = registrationService;
        this.smbCenterSambaCompanyService = smbCenterSambaCompanyService;
        this.companyService = companyService;
        this.productsService = productsService;
        this.dateFormatter = dateFormatter;
        this.confirmationService = confirmationService;
        this.ngbModalService = ngbModalService;
        this.fiscalYearService = fiscalYearService;
        this.bmeiLicenseService = bmeiLicenseService;
        this.alerts = [];
        this.subscriptions$ = new Subscription();
        this.planTypes$ = of([PlanType.SelfEmployed]);
        this.selfEmployedPlanType = PlanType.SelfEmployed;
        this.parentOwnerId = '';
        this.ownerFirmname = '';
        this.emailToSend = '';
        this.isInvited = false;
        this.isLinked = false;
        this.isUpdating = false;
        this.isOpeningOB = false;
    }
    get selectedContact() {
        return this._selectedContact;
    }
    set selectedContact(contact) {
        this._selectedContact = contact;
        if (this._selectedContact) {
            this.emailToSend = this.findPrimaryEmail(this.selectedContact.emailAddresses);
            if (this.clientId && this.companyId) {
                this.updateInvitationInfo();
            }
        }
    }
    // Waits for message event to handle post message
    postOnBalanceMessage(event) {
        if (event.origin === this.smbCompanyCredentials.sambaDomain) {
            // Send a message to onbalance with its UDSLT
            this.onbalanceWindow.postMessage({ obUDSLongToken: this.smbCompanyCredentials.sambaUdsLongToken }, this.smbCompanyCredentials.sambaUrl);
        }
    }
    /**
     * Angular component onInit lifecycle stage
     */
    ngOnInit() {
        this.dateFormatString = this.dateFormatter.getFormat();
        this.email = new FormControl(this.emailToSend, [Validators.pattern(validateEmailString)]);
        this.validations = {
            pattern: this.translateService.instant('bmei.ob.invalidEmail'),
        };
        this.updateCompanyInfo();
        this.updateLicenseInfo();
        this.updateInvitationInfo();
    }
    /**
     * Perform unsubscribe action
     */
    ngOnDestroy() {
        this.subscriptions$.unsubscribe();
    }
    /**
     * Check email list for selected contact and returns primary
     * @param emails - array of emails for selected contact
     * @returns email with isPrimary flag
     */
    findPrimaryEmail(emails) {
        return emails.length > 0 ? emails.find(address => address.isPrimary).emailAddress : '';
    }
    /**
     * Check input value matching to email regexp string
     * @returns true if form touched and value does not match pattern
     */
    validateEmail() {
        return this.email.invalid && this.email.dirty;
    }
    /**
     * Updates license info
     * @returns void
     */
    updateLicenseInfo() {
        this.registrationService
            .getOnBalanceLinkedDataForCompanyV1(this.companyId)
            .toPromise()
            .then(licenseSummary => {
            this._licenseSummary = licenseSummary;
            this._licenseSummary.availableInvitations =
                licenseSummary.availableInvitations < 0
                    ? this.translateService.instant('bmei.ob.licenseSummary.unlimited')
                    : licenseSummary.availableInvitations;
            this._licenseSummary.purchasedLicenses =
                licenseSummary.purchasedLicenses < 0
                    ? this.translateService.instant('bmei.ob.licenseSummary.unlimited')
                    : licenseSummary.purchasedLicenses;
        });
    }
    /**
     * Updates information about current client invitation
     */
    updateInvitationInfo() {
        this.isUpdating = true;
        this.registrationService
            .getCompanyMappingRecordForClientAndContactV3(this.companyId, this.clientId, this._selectedContact.id)
            .toPromise()
            .then(data => {
            this.isInvited = Boolean(data);
            this.invitedDate = data === null || data === void 0 ? void 0 : data.createdDate;
            // Linked when there is a response containing an accepted date and child company id
            this.isLinked = Boolean(Boolean(data) && data.childCompanyId && data.acceptedDate);
        })
            .finally(() => (this.isUpdating = false));
    }
    /**
     * Update information about current client company
     */
    updateCompanyInfo() {
        this.isUpdating = true;
        this.companyService
            .getCompanyInfo(this.companyId)
            .toPromise()
            .then(data => {
            var _a, _b;
            this.parentOwnerId = (_a = data.ownerContact) === null || _a === void 0 ? void 0 : _a.id;
            this.ownerFirmname = (_b = data.companyClient) === null || _b === void 0 ? void 0 : _b.name;
        })
            .finally(() => (this.isUpdating = false));
    }
    /**
     * Send invitation for selected contact
     */
    sendInvite() {
        this.isUpdating = true;
        this.productsService
            .getProducts()
            .toPromise()
            .then(products => {
            const request = {
                parentCompanyId: this.companyId,
                parentOwningContactId: this.parentOwnerId,
                clientId: this.clientId,
                registrationEmail: this.emailToSend,
                firmName: this.ownerFirmname,
                productCode: products.find(product => product.name.toLowerCase() === this.selfEmployedPlanType.toLowerCase()).id,
                contactId: this._selectedContact.id,
            };
            this.registrationService
                .createCompanyMappingV3(request)
                .toPromise()
                .then(() => {
                this.updateInvitationInfo();
                this.updateLicenseInfo();
            })
                .catch(() => (this.isUpdating = false));
        })
            .catch(() => (this.isUpdating = false));
    }
    /**
     * Cancel invitation for selected contact
     */
    cancelInvite() {
        this.deleteCompanyRegistration(this.translateService.instant('bmei.ob.cancelInvitation.successMessage'));
    }
    /**
     * Opens OnBalance page in new tab
     * @returns void
     */
    openOnBalance() {
        this.isOpeningOB = true;
        this.smbCenterSambaCompanyService
            .getAccountantUserCredentialsV2(this.selectedContact.companyId, this.clientId, this.selectedContact.id)
            .toPromise()
            .then((response) => {
            this.smbCompanyCredentials = response;
            this.onbalanceWindow = window.open(this.smbCompanyCredentials.sambaUrl, '_blank');
        })
            .catch(() => {
            this.alerts.push({
                type: 'danger',
                msg: this.translateService.instant('bmei.ob.openOnBalance.failMessage'),
                closeable: true,
            });
        })
            .finally(() => {
            this.isOpeningOB = false;
        });
    }
    /**
     * Open confirmation modal for cancel invitation
     */
    openCancelInvitationConfirmationModal() {
        this.confirmationService
            .open(this.translateService.instant('bmei.ob.buttons.cancelInvite.modal.text'), {
            confirmButtonText: this.translateService.instant('bmei.ob.buttons.cancelInvite.confirm'),
            cancelButtonText: this.translateService.instant('bmei.ob.buttons.cancelInvite.cancel'),
            iconName: 'bento-icon-warning-filled',
            iconColorType: 'danger',
        }, {
            backdrop: 'static',
            container: '.ng-bento',
            size: 'sm',
        })
            .result.then((result) => {
            if (result === BentoModalConfirmationCloseReason.Confirm) {
                this.cancelInvite();
            }
        });
    }
    /**
     * Opens a disconnect client from OB modal
     * @returns void
     */
    openDisconnectClientModal() {
        this.confirmationService
            .open(this.translateService.instant('bmei.ob.clientUnlink.bodyText'), {
            titleText: this.translateService.instant('bmei.ob.clientUnlink.titleText'),
            confirmButtonText: this.translateService.instant('bmei.ob.clientUnlink.disconnect'),
        }, {
            backdrop: 'static',
            container: '.ng-bento',
            size: 'lg',
        })
            .result.then((result) => {
            if (result === BentoModalConfirmationCloseReason.Confirm) {
                this.deleteCompanyRegistration(this.translateService.instant('bmei.ob.clientUnlink.success'));
            }
        });
    }
    /**
     * Delete company registration for the client and contact.
     */
    deleteCompanyRegistration(successMessage) {
        this.isUpdating = true;
        this.registrationService
            .deleteCompanyMappingRecordForClientAndContactV3(this.companyId, this.clientId, this._selectedContact.id)
            .toPromise()
            .then(() => {
            this.alerts.push({
                type: 'success',
                msg: successMessage,
                closeable: true,
                timeout: 5000,
            });
            this.updateInvitationInfo();
            this.updateLicenseInfo();
        })
            .catch(() => (this.isUpdating = false));
    }
    /**
     * Opens a modal for request prior period data
     */
    openRequestPeriodModal() {
        this.isUpdating = true;
        this.fiscalYearService
            .get(this._selectedContact.id, true)
            .toPromise()
            .then(data => {
            if (!data) {
                return;
            }
            const yearsWithPriorPeriods = data.filter(year => this.havePriorPeriods(year));
            const modalRef = this.ngbModalService.open(RequestPeriodModalComponent, {
                backdrop: 'static',
                keyboard: false,
                container: '.ng-bento',
            });
            modalRef.componentInstance.contactName = this._selectedContact.displayAs;
            modalRef.componentInstance.fiscalYears = of(yearsWithPriorPeriods);
            modalRef.closed.toPromise().then(fiscalYear => {
                if (fiscalYear) {
                    const alerts = this.createPriorPeriodAlertRequestObject(fiscalYear);
                    this.createAlerts(alerts);
                }
            });
        })
            .finally(() => (this.isUpdating = false));
    }
    /**
     * Creates AlertsV1Dto object from selected fiscal year
     * @param year - selected financial year from combobox
     * @returns AlertsV1Dto object
     */
    createPriorPeriodAlertRequestObject(year) {
        if (!year) {
            return;
        }
        return {
            reason: priorPeriodRequestReason,
            periods: this.getPriorPeriod(year.periods).map(period => {
                return {
                    startDate: period.startDate,
                    endDate: period.endDate,
                };
            }),
        };
    }
    /**
     * Creates request for sending alerts
     * @param alerts - AlertsV1Dto object for send
     */
    createAlerts(alerts) {
        this.isUpdating = true;
        this.smbCenterSambaCompanyService
            .createAlerts(this.companyId, this.clientId, this._selectedContact.id, alerts)
            .toPromise()
            .then(() => {
            this.alerts.push({
                type: 'success',
                timeout: 5000,
                msg: this.translateService.instant('bmei.ob.requestPriorPeriod.requestSuccess'),
                closeable: true,
            });
        })
            .finally(() => (this.isUpdating = false));
    }
    /**
     * Checks fiscal year for prior periods having
     * @param year - fiscal year with period to check
     * @returns boolean value
     */
    havePriorPeriods(year) {
        if (year.periods && year.periods.length > 0) {
            const priorPeriods = this.getPriorPeriod(year.periods);
            return priorPeriods && priorPeriods.length > 0;
        }
    }
    /**
     * Filter periods, removes non prior periods
     * @param periods - periods to filter
     * @returns filtered periods array
     */
    getPriorPeriod(periods) {
        return periods.filter(period => new Date(period.endDate) < new Date() && period.periodType === PeriodType.Accounting);
    }
}
OnbalanceIntegrationComponent.ɵfac = function OnbalanceIntegrationComponent_Factory(t) { return new (t || OnbalanceIntegrationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.SmbCenterCompanyRegistartionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.SmbCenterSambaCompanyService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CompanyService), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.SmbCenterProductsService), ɵngcc0.ɵɵdirectiveInject(BmeiDateFormatterService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.BentoModalConfirmationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FiscalYearService), ɵngcc0.ɵɵdirectiveInject(BmeiLicenseService)); };
OnbalanceIntegrationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OnbalanceIntegrationComponent, selectors: [["bmei-onbalance-integration-component"]], hostBindings: function OnbalanceIntegrationComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("message", function OnbalanceIntegrationComponent_message_HostBindingHandler($event) { return ctx.postOnBalanceMessage($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { selectedContact: "selectedContact", iacModel: "iacModel", companyId: "companyId", showOnbalanceConnectOptions: "showOnbalanceConnectOptions", clientId: "clientId" }, decls: 50, vars: 25, consts: [[3, "items"], [1, "bmei-card-wrapper", 3, "bentoBusyLoader"], [1, "card"], [1, "card-header"], [1, "card-body"], [1, "row", "justify-content-between"], ["class", "col-lg-6 col-xl-7", 4, "ngIf"], [1, "col-lg-6", "col-xl-5"], ["src", "assets/external-integration/img/ONBALANCE_logo.svg", 1, "bmei-ob-logo-img"], [1, "bmei-ob-license-summary"], [1, "row"], [1, "col-md-8", "col-sm-8", "col-xs-8"], [1, "col-md-4", "col-sm-4", "col-xs-4"], [1, "text-right"], ["ng-if", "!vm.isARCountryCode", 1, "bm-section-divider"], ["tipContent", ""], [1, "col-lg-6", "col-xl-7"], ["class", "form-group bmei-client-status-notification", 4, "ngIf"], [4, "ngIf"], [1, "form-group", "bmei-client-status-notification"], [1, "bento-icon-info-filled"], [3, "innerHTML"], ["placement", "top", "tooltipClass", "bmei-ob-tooltip", 1, "bento-icon-info", 3, "ngbTooltip"], [1, "bmei-client-status-notification"], [1, "bento-icon-save-solid"], [1, "form-group", "bmei-client-linked-buttons"], ["data-qe-id", "bmei-ob-open-onbalance", "class", "btn btn-primary", 3, "disabled", "click", 4, "ngIf"], ["data-qe-id", "bmei-ob-request-prior-data", 1, "btn", "btn-default", 3, "click"], ["data-qe-id", "bmei-ob-disconnect-client", "class", "btn btn-default", 3, "click", 4, "ngIf"], ["data-qe-id", "bmei-ob-open-onbalance", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "bento-icon-newtab"], ["data-qe-id", "bmei-ob-disconnect-client", 1, "btn", "btn-default", 3, "click"], ["bfmForm", "", "name", "emailForm", 1, "form-group", 3, "validations"], ["for", "email"], ["translate", "bmei.ob.emailAddress"], ["bfmField", "", 1, "form-control", 3, "bfmLabel", "ngModel", "formControl", "ngModelChange"], [1, "form-group", "bmei-ob-combobox-container"], [1, "bmei-ob-label"], ["translate", "bmei.ob.plan.combobox.label"], ["attr.data-qe-id", "bmei.ob.plan.combobox", 1, "bmei-ob-combobox", 3, "itemsObservable", "ngModel", "appendTo"], ["type", "submit", "class", "btn btn-primary", "data-qe-id", "bmei-ob-send-invitation", 3, "disabled", "click", 4, "ngIf"], ["class", "form-group bmei-buttons-container", 4, "ngIf"], [1, "bmei-ob-required"], ["type", "submit", "data-qe-id", "bmei-ob-send-invitation", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "form-group", "bmei-buttons-container"], ["type", "submit", "data-qe-id", "bmei-ob-resend-invitation", 1, "btn", "btn-primary", 3, "disabled", "click"], ["type", "submit", "data-qe-id", "bmei-ob-cancel-invitation", 1, "btn", "btn-default", 3, "click"], [1, "bmei-ob-tooltip-title"], [1, "bmei-ob-tooltip-text"]], template: function OnbalanceIntegrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4)(7, "div", 5);
        ɵngcc0.ɵɵtemplate(8, OnbalanceIntegrationComponent_div_8_Template, 4, 3, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelement(10, "img", 8);
        ɵngcc0.ɵɵelementStart(11, "h3");
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 9)(15, "div", 10)(16, "div", 11)(17, "p");
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(20, "div", 12)(21, "p", 13);
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(23, "div", 10)(24, "div", 11)(25, "p");
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵpipe(27, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(28, "div", 12)(29, "p", 13);
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(31, "div", 10)(32, "div", 11)(33, "p");
        ɵngcc0.ɵɵtext(34);
        ɵngcc0.ɵɵpipe(35, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(36, "div", 12)(37, "p", 13);
        ɵngcc0.ɵɵtext(38);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelement(39, "hr", 14);
        ɵngcc0.ɵɵelementStart(40, "div", 10)(41, "div", 11)(42, "p");
        ɵngcc0.ɵɵtext(43);
        ɵngcc0.ɵɵpipe(44, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(45, "div", 12)(46, "p", 13);
        ɵngcc0.ɵɵtext(47);
        ɵngcc0.ɵɵelementEnd()()()()()()()()();
        ɵngcc0.ɵɵtemplate(48, OnbalanceIntegrationComponent_ng_template_48_Template, 7, 6, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isUpdating);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 13, "bmei.ob.integrationOb"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOnbalanceConnectOptions);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 15, "bmei.ob.licenseSummary"));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 17, "bmei.ob.licenseSummary.purchasedLicenses"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx._licenseSummary == null ? null : ctx._licenseSummary.purchasedLicenses);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(27, 19, "bmei.ob.licenseSummary.registeredLicenses"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx._licenseSummary == null ? null : ctx._licenseSummary.registeredLicenses);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(35, 21, "bmei.ob.licenseSummary.outstandingInvitations"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx._licenseSummary == null ? null : ctx._licenseSummary.outstandingInvitations);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(44, 23, "bmei.ob.licenseSummary.availableLicenses"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx._licenseSummary == null ? null : ctx._licenseSummary.availableInvitations);
    } }, directives: [ɵngcc5.BentoAlertComponent, ɵngcc5.BentoBusyLoaderDirective, ɵngcc4.NgIf, ɵngcc7.NgbTooltip, ɵngcc5.BentoNgbTooltipSupportDirective, ɵngcc5.BentoFocusMonitorDirective, ɵngcc6.ɵNgNoValidate, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm, ɵngcc9.BfmFormDirective, ɵngcc3.TranslateDirective, ɵngcc6.DefaultValueAccessor, ɵngcc9.BfmFieldDirective, ɵngcc6.NgControlStatus, ɵngcc6.FormControlDirective, ɵngcc5.BentoComboboxComponent, ɵngcc6.NgModel], pipes: [ɵngcc3.TranslatePipe, ɵngcc4.DatePipe], styles: [".bmei-card-wrapper{padding-top:10px}.bmei-card-wrapper .row.justify-content-between:after,.bmei-card-wrapper .row.justify-content-between:before{content:none!important}.bmei-card-wrapper input{color:inherit!important}.bmei-card-wrapper .bmei-client-linked-buttons{margin-top:20px}.bmei-card-wrapper .bmei-client-linked-buttons button{padding:18px;margin:5px 3px}.bmei-card-wrapper .bmei-buttons-container button{margin-right:10px!important}.bmei-ob-logo-img{width:355px;height:154px}.bmei-ob-label{margin-bottom:10px}bento-combobox.bmei-ob-combobox{right:0!important}bento-combobox.bmei-ob-combobox input{background-color:#fff!important;border:1px solid #939393!important}.bmei-ob-license-summary{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.bmei-ob-required{margin-top:30px!important}.bmei-client-status-notification{display:flex!important;align-items:center}.bmei-client-status-notification i.bento-icon-info:before{font-size:20px;margin-left:5px}.bmei-client-status-notification i.bento-icon-save-solid:before{color:#2c6a2d;font-size:20px;margin-right:5px}.bmei-client-status-notification i.bento-icon-info-filled:before{color:#349bcc;font-size:20px;margin-right:5px}.bmei-ob-tooltip{padding:0!important}.bmei-ob-tooltip .tooltip-inner{max-width:440px!important;text-align:left!important;padding:20px 10px!important}.bmei-ob-tooltip .tooltip-inner .bmei-ob-tooltip-title{font-size:14px;margin-bottom:10px}.bmei-ob-tooltip .tooltip-inner .bmei-ob-tooltip-text{font-size:12px}.bmei-ob-tooltip .arrow{height:0!important}.ng-bento .modal-footer .btn{margin-bottom:3px}"], encapsulation: 2 });
OnbalanceIntegrationComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: SmbCenterCompanyRegistartionService },
    { type: SmbCenterSambaCompanyService },
    { type: CompanyService },
    { type: SmbCenterProductsService },
    { type: BmeiDateFormatterService },
    { type: BentoModalConfirmationService },
    { type: NgbModal },
    { type: FiscalYearService },
    { type: BmeiLicenseService }
];
OnbalanceIntegrationComponent.propDecorators = {
    iacModel: [{ type: Input }],
    companyId: [{ type: Input }],
    showOnbalanceConnectOptions: [{ type: Input }],
    selectedContact: [{ type: Input }],
    clientId: [{ type: Input }],
    postOnBalanceMessage: [{ type: HostListener, args: ['window:message', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OnbalanceIntegrationComponent, [{
        type: Component,
        args: [{
                selector: 'bmei-onbalance-integration-component',
                template: "<bento-alert [items]=\"alerts\"></bento-alert>\n<div class=\"bmei-card-wrapper\" [bentoBusyLoader]=\"isUpdating\">\n\t<div class=\"card\">\n\t\t<div class=\"card-header\">{{'bmei.ob.integrationOb' | translate}}</div>\n\t\t<div class=\"card-body\">\n\t\t\t<div class=\"row justify-content-between\">\n\t\t\t\t<div class=\"col-lg-6 col-xl-7\" *ngIf=\"showOnbalanceConnectOptions\">\n\t\t\t\t\t<div *ngIf=\"isInvited && !isLinked\" class=\"form-group bmei-client-status-notification\">\n\t\t\t\t\t\t<i class=\"bento-icon-info-filled\"></i>\n\t\t\t\t\t\t<span\n\t\t\t\t\t\t\t[innerHTML]=\"'bmei.ob.invitationSent' | translate: { contact: this._selectedContact.displayAs, date: this.invitedDate | date: this.dateFormatString}\"\n\t\t\t\t\t\t></span>\n\t\t\t\t\t\t<i class=\"bento-icon-info\" [ngbTooltip]=\"tipContent\" placement=\"top\" tooltipClass=\"bmei-ob-tooltip\"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div *ngIf=\"isLinked\">\n\t\t\t\t\t\t<div class=\"bmei-client-status-notification\">\n\t\t\t\t\t\t\t<i class=\"bento-icon-save-solid\"></i>\n\t\t\t\t\t\t\t<span [innerHTML]=\"'bmei.ob.linkSuccess' | translate: { contact: this._selectedContact.displayAs }\"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"form-group bmei-client-linked-buttons\">\n\t\t\t\t\t\t\t<!-- OpenOnbalance button -->\n\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\tdata-qe-id=\"bmei-ob-open-onbalance\"\n\t\t\t\t\t\t\t\tclass=\"btn btn-primary\"\n\t\t\t\t\t\t\t\t(click)=\"openOnBalance()\"\n\t\t\t\t\t\t\t\t[disabled]=\"isOpeningOB\"\n\t\t\t\t\t\t\t\t*ngIf=\"iacModel?.hasOBAccountantView\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<span> {{ 'bmei.ob.openOnBalance' | translate }} </span>\n\t\t\t\t\t\t\t\t<i class=\"bento-icon-newtab\"> </i>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<!-- Request prior data button -->\n\t\t\t\t\t\t\t<button data-qe-id=\"bmei-ob-request-prior-data\" class=\"btn btn-default\" (click)=\"openRequestPeriodModal()\">\n\t\t\t\t\t\t\t\t<b>{{ 'bmei.ob.requestPriorData' | translate }}</b>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<!-- Disconnect button -->\n\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\t*ngIf=\"bmeiLicenseService?.hasOnbalanceDisconnect\"\n\t\t\t\t\t\t\t\tdata-qe-id=\"bmei-ob-disconnect-client\"\n\t\t\t\t\t\t\t\tclass=\"btn btn-default\"\n\t\t\t\t\t\t\t\t(click)=\"openDisconnectClientModal()\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<b>{{ 'bmei.ob.clientUnlink.disconnect' | translate }}</b>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div *ngIf=\"!isLinked\">\n\t\t\t\t\t\t<form bfmForm name=\"emailForm\" class=\"form-group\" [validations]=\"validations\">\n\t\t\t\t\t\t\t<label for=\"email\"><span translate=\"bmei.ob.emailAddress\"></span></label>\n\t\t\t\t\t\t\t<input\n\t\t\t\t\t\t\t\tbfmField\n\t\t\t\t\t\t\t\tbfmLabel=\"{{ 'bmei.ob.emailAddress' | translate }}\"\n\t\t\t\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\t\t\t\t[(ngModel)]=\"emailToSend\"\n\t\t\t\t\t\t\t\t[formControl]=\"email\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</form>\n\t\t\t\t\t\t<div class=\"form-group bmei-ob-combobox-container\">\n\t\t\t\t\t\t\t<label class=\"bmei-ob-label\"><span translate=\"bmei.ob.plan.combobox.label\"></span></label>\n\t\t\t\t\t\t\t<bento-combobox\n\t\t\t\t\t\t\t\tclass=\"bmei-ob-combobox\"\n\t\t\t\t\t\t\t\tattr.data-qe-id=\"bmei.ob.plan.combobox\"\n\t\t\t\t\t\t\t\t[itemsObservable]=\"planTypes$\"\n\t\t\t\t\t\t\t\t[ngModel]=\"selfEmployedPlanType\"\n\t\t\t\t\t\t\t\t[appendTo]=\"'.bmei-ob-combobox-container'\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t</bento-combobox>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t*ngIf=\"!isInvited\"\n\t\t\t\t\t\t\ttype=\"submit\"\n\t\t\t\t\t\t\tclass=\"btn btn-primary\"\n\t\t\t\t\t\t\tdata-qe-id=\"bmei-ob-send-invitation\"\n\t\t\t\t\t\t\t[disabled]=\"!this.emailToSend || validateEmail()\"\n\t\t\t\t\t\t\t(click)=\"sendInvite()\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t{{'bmei.ob.buttons.sendInvite' | translate}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<div *ngIf=\"isInvited\" class=\"form-group bmei-buttons-container\">\n\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\ttype=\"submit\"\n\t\t\t\t\t\t\t\tclass=\"btn btn-primary\"\n\t\t\t\t\t\t\t\tdata-qe-id=\"bmei-ob-resend-invitation\"\n\t\t\t\t\t\t\t\t[disabled]=\"!this.emailToSend || validateEmail()\"\n\t\t\t\t\t\t\t\t(click)=\"sendInvite()\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t{{'bmei.ob.buttons.reSendInvite' | translate}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t<button\n\t\t\t\t\t\t\t\ttype=\"submit\"\n\t\t\t\t\t\t\t\tclass=\"btn btn-default\"\n\t\t\t\t\t\t\t\tdata-qe-id=\"bmei-ob-cancel-invitation\"\n\t\t\t\t\t\t\t\t(click)=\"openCancelInvitationConfirmationModal()\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t{{'bmei.ob.buttons.cancelInvite' | translate}}\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"bmei-ob-required\">{{'bmei.integration.requiredField' | translate}}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"col-lg-6 col-xl-5\">\n\t\t\t\t\t<img class=\"bmei-ob-logo-img\" src=\"assets/external-integration/img/ONBALANCE_logo.svg\" />\n\t\t\t\t\t<h3>{{'bmei.ob.licenseSummary' | translate}}</h3>\n\t\t\t\t\t<div class=\"bmei-ob-license-summary\">\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-8\">\n\t\t\t\t\t\t\t\t<p>{{ 'bmei.ob.licenseSummary.purchasedLicenses' | translate }}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-4 col-sm-4 col-xs-4\">\n\t\t\t\t\t\t\t\t<p class=\"text-right\">{{_licenseSummary?.purchasedLicenses}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-8\">\n\t\t\t\t\t\t\t\t<p>{{ 'bmei.ob.licenseSummary.registeredLicenses' | translate }}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-4 col-sm-4 col-xs-4\">\n\t\t\t\t\t\t\t\t<p class=\"text-right\">{{_licenseSummary?.registeredLicenses}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-8\">\n\t\t\t\t\t\t\t\t<p>{{ 'bmei.ob.licenseSummary.outstandingInvitations' | translate }}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-4 col-sm-4 col-xs-4\">\n\t\t\t\t\t\t\t\t<p class=\"text-right\">{{_licenseSummary?.outstandingInvitations}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<hr class=\"bm-section-divider\" ng-if=\"!vm.isARCountryCode\" />\n\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t<div class=\"col-md-8 col-sm-8 col-xs-8\">\n\t\t\t\t\t\t\t\t<p>{{ 'bmei.ob.licenseSummary.availableLicenses' | translate }}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"col-md-4 col-sm-4 col-xs-4\">\n\t\t\t\t\t\t\t\t<p class=\"text-right\">{{_licenseSummary?.availableInvitations}}</p>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n<ng-template #tipContent>\n\t<div class=\"bmei-ob-tooltip-title\"><b>{{'bmei.ob.tooltip.title' | translate}}</b></div>\n\t<div class=\"bmei-ob-tooltip-text\">{{'bmei.ob.tooltip.text' | translate}}</div>\n</ng-template>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmei-card-wrapper{padding-top:10px}.bmei-card-wrapper .row.justify-content-between:after,.bmei-card-wrapper .row.justify-content-between:before{content:none!important}.bmei-card-wrapper input{color:inherit!important}.bmei-card-wrapper .bmei-client-linked-buttons{margin-top:20px}.bmei-card-wrapper .bmei-client-linked-buttons button{padding:18px;margin:5px 3px}.bmei-card-wrapper .bmei-buttons-container button{margin-right:10px!important}.bmei-ob-logo-img{width:355px;height:154px}.bmei-ob-label{margin-bottom:10px}bento-combobox.bmei-ob-combobox{right:0!important}bento-combobox.bmei-ob-combobox input{background-color:#fff!important;border:1px solid #939393!important}.bmei-ob-license-summary{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.bmei-ob-required{margin-top:30px!important}.bmei-client-status-notification{display:flex!important;align-items:center}.bmei-client-status-notification i.bento-icon-info:before{font-size:20px;margin-left:5px}.bmei-client-status-notification i.bento-icon-save-solid:before{color:#2c6a2d;font-size:20px;margin-right:5px}.bmei-client-status-notification i.bento-icon-info-filled:before{color:#349bcc;font-size:20px;margin-right:5px}.bmei-ob-tooltip{padding:0!important}.bmei-ob-tooltip .tooltip-inner{max-width:440px!important;text-align:left!important;padding:20px 10px!important}.bmei-ob-tooltip .tooltip-inner .bmei-ob-tooltip-title{font-size:14px;margin-bottom:10px}.bmei-ob-tooltip .tooltip-inner .bmei-ob-tooltip-text{font-size:12px}.bmei-ob-tooltip .arrow{height:0!important}.ng-bento .modal-footer .btn{margin-bottom:3px}"]
            }]
    }], function () { return [{ type: ɵngcc3.TranslateService }, { type: ɵngcc8.SmbCenterCompanyRegistartionService }, { type: ɵngcc8.SmbCenterSambaCompanyService }, { type: ɵngcc1.CompanyService }, { type: ɵngcc8.SmbCenterProductsService }, { type: BmeiDateFormatterService }, { type: ɵngcc5.BentoModalConfirmationService }, { type: ɵngcc7.NgbModal }, { type: ɵngcc1.FiscalYearService }, { type: BmeiLicenseService }]; }, { selectedContact: [{
            type: Input
        }], 
    // Waits for message event to handle post message
    postOnBalanceMessage: [{
            type: HostListener,
            args: ['window:message', ['$event']]
        }], iacModel: [{
            type: Input
        }], companyId: [{
            type: Input
        }], showOnbalanceConnectOptions: [{
            type: Input
        }], clientId: [{
            type: Input
        }] }); })();

class ExternalIntegrationModule {
}
ExternalIntegrationModule.ɵfac = function ExternalIntegrationModule_Factory(t) { return new (t || ExternalIntegrationModule)(); };
ExternalIntegrationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ExternalIntegrationModule });
ExternalIntegrationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [BmeiContactService, BmeiDateFormatterService], imports: [[
            CommonModule,
            BrowserModule,
            FormsModule,
            TranslateModule.forChild(),
            HttpClientModule,
            NgbModule,
            BentoModule,
            BfmModule,
            AccountingServicesModule,
            QuickbooksOnlineServicesModule,
            FormsModule,
            ReactiveFormsModule,
            OnBalanceServicesModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExternalIntegrationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ExternalIntegrationComponent,
                    ContactSelectorComponent,
                    OnbalanceIntegrationComponent,
                    QuickBooksIntegrationComponent,
                    QuickBooksIntegrationCallbackComponent,
                    LicenseAgreementModalComponent,
                    QboDisconnectModalComponent,
                    RequestPeriodModalComponent,
                ],
                imports: [
                    CommonModule,
                    BrowserModule,
                    FormsModule,
                    TranslateModule.forChild(),
                    HttpClientModule,
                    NgbModule,
                    BentoModule,
                    BfmModule,
                    AccountingServicesModule,
                    QuickbooksOnlineServicesModule,
                    FormsModule,
                    ReactiveFormsModule,
                    OnBalanceServicesModule,
                ],
                providers: [BmeiContactService, BmeiDateFormatterService],
                exports: [ExternalIntegrationComponent, QuickBooksIntegrationCallbackComponent],
                entryComponents: [
                    ExternalIntegrationComponent,
                    LicenseAgreementModalComponent,
                    QboDisconnectModalComponent,
                    QuickBooksIntegrationCallbackComponent,
                    RequestPeriodModalComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ExternalIntegrationModule, { declarations: function () { return [ExternalIntegrationComponent, ContactSelectorComponent, OnbalanceIntegrationComponent, QuickBooksIntegrationComponent, QuickBooksIntegrationCallbackComponent, LicenseAgreementModalComponent, QboDisconnectModalComponent, RequestPeriodModalComponent]; }, imports: function () { return [CommonModule,
        BrowserModule,
        FormsModule, ɵngcc3.TranslateModule, HttpClientModule,
        NgbModule,
        BentoModule,
        BfmModule,
        AccountingServicesModule,
        QuickbooksOnlineServicesModule,
        FormsModule,
        ReactiveFormsModule,
        OnBalanceServicesModule]; }, exports: function () { return [ExternalIntegrationComponent, QuickBooksIntegrationCallbackComponent]; } }); })();

/*
 * Public API Surface of external-integration
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ExternalIntegrationComponent, ExternalIntegrationModule, QuickBooksIntegrationCallbackComponent, BmeiContactService as ɵa, BmeiLicenseService as ɵb, ContactSelectorComponent as ɵc, OnbalanceIntegrationComponent as ɵd, BmeiDateFormatterService as ɵe, QuickBooksIntegrationComponent as ɵf, LicenseAgreementModalComponent as ɵg, QboDisconnectModalComponent as ɵh, RequestPeriodModalComponent as ɵi };

